export default "__VITE_ASSET__93023773__"